import { claudePrompt } from './claude';
import { codexPrompt } from './codex';
import { cursorPrompt } from './cursor';
import { genericPrompt } from './generic';

/**
 * Keep provider-specific onboarding prompts addressable from one import surface.
 */
export const prompt = {
    claude: claudePrompt,
    codex: codexPrompt,
    cursor: cursorPrompt,
    generic: genericPrompt,
};
